import React, { useState } from 'react';
import { FEATURE_CARDS } from '@/shared/constants/homepage-constants';
import { HomepageFeatureCard } from '@/shared/types/homepage';
import { useRouter } from 'next/router';
import { Play } from '@/components/Common/Icons';
import Image from 'next/image';
import VimeoDialog from '@/components/Common/VimeoDialog';
import { isNull, map } from 'lodash-es';
import './index.less';

const FeatureCardsSection = () => {
  const router = useRouter();
  const [vimeoId, setVimeoId] = useState<number>(null);

  const featureCard = (card: HomepageFeatureCard) => {
    return (
      <div
        key={card.path}
        className="feature-card"
        onClick={() => {
          if (card?.external) {
            window.open(card.path, '_blank');
          } else {
            router.push(card.path);
          }
        }}
      >
        <div className="container">
          <Image
            src={card.img}
            alt={card.title}
            width={200}
            height={150}
            sizes="auto,(min-width:300px) 107px,(min-width:600px) 133.34px, (min-width:820px) 200px, 107px"
          />
          {card.vimeoId && (
            <Play
              className="play-icon"
              onClick={(e: React.MouseEvent) => {
                e.stopPropagation();
                setVimeoId(card?.vimeoId);
              }}
            />
          )}
        </div>
        <div className="container">
          <h3 className="title">{card.title}</h3>
          <p className="desc">{card.desc}</p>
        </div>
        <div className="btn-container">
          <button className="button">
            <span>Learn more</span>
          </button>
        </div>
      </div>
    );
  };

  return (
    <div className="feature-cards-section">
      <div className="content-max">
        <div className="grid">{map(FEATURE_CARDS, featureCard)}</div>
      </div>
      <VimeoDialog videoId={vimeoId} visible={!isNull(vimeoId)} autoplay={true} onClose={() => setVimeoId(null)} />
    </div>
  );
};

export default FeatureCardsSection;
